import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';

import { L10nService } from '@nano/core/l10n';
import { Classifier, ClassifierService, GlossaryId } from '@nano/common/classifier';

@Injectable({
  providedIn: 'root'
})
export class BankCodeTypeService {
  readonly bankCodeTypes$: Observable<Classifier[]>;

  constructor(
    private classifierService: ClassifierService,
    private l10nService: L10nService
  ) {
    this.bankCodeTypes$ = this.l10nService.schema$.pipe(
      switchMap(() => this.classifierService.getGlossary(GlossaryId.SWIFT_XML_BANK_CODE_TYPE)),
      shareReplay({ refCount: false, bufferSize: 1 })
    );
  }
}
